import { Location } from '@angular/common';
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  inject,
  model,
  ElementRef,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DrawerModule, Drawer } from 'primeng/drawer';
import { IconFieldModule } from 'primeng/iconfield';
import { InplaceModule } from 'primeng/inplace';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';

import { ThemeService } from '@offconon/shared/ui/theme-switch';

@Component({
  selector: 'offconon-left-sidebar',
  imports: [
    DrawerModule,
    MatIcon,
    TooltipModule,
    TranslateModule,
    ButtonModule,
    InplaceModule,
    DrawerModule,
    IconFieldModule,
    InputIconModule,
    InputTextModule,
    RouterModule,
  ],
  templateUrl: './layout-left-sidebar.component.html',
  styleUrl: './layout-left-sidebar.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class LayoutLeftSidebarComponent implements OnInit, OnChanges {
  translate = inject(TranslateService);
  private router = inject(Router);
  private location = inject(Location);

  sideBarVisible = model(true);
  @Input() sideNavData: any;
  @ViewChild('searchInput') private searchInput: ElementRef;
  @ViewChild('appSidebar') private appSidebar: Drawer;

  filteredNavData: any;
  isMobileView = true;
  public activeTab = 0;
  visible = false;

  constructor() {
    inject(ThemeService).mobileView.subscribe({
      next: (isMobileView: boolean) => {
        this.isMobileView = isMobileView;
      },
    });
  }

  ngOnInit(): void {
    this.getActiveLink();
  }

  ngOnChanges(): void {
    this.getActiveLink();

    this.filteredNavData = this.sideNavData;
  }

  closeDrawer() {
    this.resetSideBar();
  }

  resetFilter() {
    this.filteredNavData = this.sideNavData;
    this.searchInput.nativeElement.value = '';
  }
  clickErpImg() {
    this.router.navigate(['/']);
  }

  getActiveLink() {
    if (this.sideNavData !== undefined) {
      this.findActiveUrl();
      this.router.events.subscribe((event: any) => {
        if (event instanceof NavigationEnd) {
          this.findActiveUrl();
        }
      });
    }
  }

  findActiveUrl() {
    const url = this.location.path().split('/')[2];
    this.sideNavData.forEach((element: any, index: number) => {
      element.elements.find((item: any) => {
        if (item.activeUrl === url) {
          this.activeTab = index;
        }
      });
    });
  }

  onSearchChange(searchValue: any): void {
    if (searchValue.value === '') {
      this.filteredNavData = this.sideNavData;
      return;
    }
    this.filteredNavData = [];

    this.sideNavData
      .filter((sidenav: { visible: any }) => {
        return sidenav.visible;
      })
      .forEach((item: any, index: number) => {
        const filtered = item.elements.filter((element: any) => {
          return (
            element.firstLine.toLowerCase().includes(searchValue.value.toLowerCase()) &&
            element.visible === true
          );
        });

        if (filtered.length > 0) {
          this.filteredNavData[index] = {
            name: item.name,
            elements: filtered,
            menuIcon: item.menuIcon,
            visible: true,
          };
        } else {
          this.filteredNavData[index] = {};
        }
      });
    this.filteredNavData = [...this.filteredNavData];
  }
  resetSideBar() {
    this.sideBarVisible.set(false);
    this.resetFilter();
  }
  public hideSideBar(): void {
    this.appSidebar.hide();

    this.sideBarVisible.set(false);
  }
}
